import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import cancelOffer from "astrid-firestore/src/api/offers/cancelOffer";
import {
	cancellableOfferStatuses,
	deleteableOfferStatuses,
} from "astrid-firestore/src/api/offers/constants/offerStatuses";
import deleteOffer from "astrid-firestore/src/api/offers/deleteOffer";

import { getProfile } from "../../../../authentication/state/profile";
import DropdownMenu from "../../../../ui/components/DropdownMenu/DropdownMenu";

export default function OpenOfferDropdownMenu({ offer }) {
	const { t } = useTranslation();

	const options = [
		{
			text: t("cancel", "Cancel"),
			disabled: !cancellableOfferStatuses.includes(offer.status),
			confirmText: t("cancelOfferConfirmation", "Are you sure you want to cancel this offer?"),
			action: () => cancelOffer(firebase, { offer }),
		},
		{
			text: t("remove", "Remove"),
			disabled: !deleteableOfferStatuses.includes(offer.status),
			confirmText: t("deleteOfferConfirmation", "Are you sure you want to delete this offer?"),
			action: async () => {
				try {
					await deleteOffer(firebase, { offer, user: getProfile() });
				} catch (error) {
					console.error(error);
					throw new Error(t("failedToDeleteOffer", "Failed to delete offer"));
				}
			},
		},
	];

	return <DropdownMenu options={options} />;
}
